import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
    chatContainer: {
        minWidth: '241px',
        background: '#202122',
        border: '1px solid #3F3F3F',
    },

    chatContentContainer: {
        //borderBottom: '1px solid #3f3f3f',
        // paddingLeft: '10px',
        // paddingRight: '10px',
        // marginLeft: '16px',
        // marginRight: '16px',
        width: '100%',
        minWidth: '100%',
        gridColumn: '1 / 1',
        gridRow: '1 / 1',
        zIndex: 1,

        display: 'flex',
        flexDirection: 'column',
        height: '45vh',
    },

    accordianSummary: {
        textAlign: 'center',
        '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: '48px',
        },
        '& .MuiAccordionSummary-content': {
            margin: 0,
        },
        '& .MuiSvgIcon-root': {
            fill: '#F1F1F1',
            height: '20px',
            width: '20px',
        },

        '& .MuiBadge-root': {
            width: '100%',

            '& .MuiBadge-badge': {
                top: '8px',
                right: '70px',
                transform: 'unset',
            },
        },

        '& .MuiAccordionSummary-expandIcon': {
            transition: 'none',
        },
    },

    accordianHeader: {
        width: '100%',
        paddingLeft: '30px',
    },

    accordianDetails: {
        flexDirection: 'column',
        overflow: 'hidden',
        padding: '2px 0px 12px',
    },

    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '10px',
    },

    chatButton: {
        width: '100px',
        margin: '0px 10px',
        fontWeight: 300,
        borderRadius: '16px',
        '& .MuiButton-label': {
            fontSize: '12px',
            color: '#F9CC04',
            textTransform: 'none',
        },
    },

    chatButtonFilled: {
        backgroundColor: '#f9cc04 !important',
        '& .MuiButton-label': {
            color: '#202122',
        },
    },

    chatSender: {
        display: 'inline-block',
        marginRight: '0.5rem',
    },

    chatMessage: {
        display: 'inline-block',
        whiteSpace: 'pre-line',
        '& .chat-hyperlink': {
            color: '#F9CC04',
        },
    },

    chatMessageLine: {
        marginBottom: 2,
        '& .chat-hyperlink': {
            color: '#F9CC04',
        },
    },

    chatTextBox: {
        margin: '14px 0px 8px 0',
        padding: '0px 18px',

        '& .MuiInputBase-root': {
            color: '#f1f1f1',
            fontSize: '11pt',
            padding: '14px 12px',
        },

        '& .MuiFormLabel-root': {
            color: '#5D5D5D',
        },

        '& .MuiOutlinedInput-notchedOutline': {
            border: '1px solid #F1F1F1 !important',
        },
    },

    scrollableSection: {
        //maxHeight: '33vh',
        height: '100%',
        overflowY: 'auto',

        // We leave a padding space for the potential scrollbar.
        //paddingRight: '27px',
        //paddingLeft: '27px',
        paddingRight: '1.4rem',
        paddingLeft: '1.4rem',

        '& pre': {
            whiteSpace: 'unset',
        },
    },

    fileContainer: {
        width: '100%',
        maxWidth: '265px',
        height: 'fit-content',
        border: '1px dashed #5D5D5D',
        borderRadius: '5px',
        display: 'flex',
        flexDirection: 'column',
        padding: '0.4rem 0.5rem',
        gap: '0 5px',
    },

    chatCellContainer: {
        padding: '0.4rem 0',
        wordBreak: 'break-word',
    },

    chatTimestamp: {
        color: '#5d5d5d',
        fontSize: '80%',
    },

    fileLink: {
        color: '#F1F1F1',
    },

    fileSublink: {
        color: '#5d5d5d',
        fontSize: '85%',
        whiteSpace: 'nowrap',
    },

    fileboxSubtext: {
        color: '#5D5D5D',
        fontSize: '85%',
    },

    greyText: {
        color: '#5D5D5D',
        width: '100%',
        textAlign: 'center',
    },

    rectangle: {
        height: '32px',
        width: '30px',
        border: '1px solid rgb(93, 93, 93)',
        borderRadius: '5px',
        marginTop: '5px',
        marginBottom: '5px',
        cursor: 'pointer',

        '& svg': {
            width: '28px',
            height: '30px',
            color: 'rgb(93, 93, 93)',
            padding: '2px',
        },
    },
}))

export default useStyles
